<template>
  <el-col :span="24">

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        align="center"
        label="类型"
        width="150"
      />

      <el-table-column
        align="center"
        label="是否付费"
        width="150"
      >
        <template v-slot:default="{row}">
          <span v-if="row.is_pay=== 1">付费</span>
          <span v-else>免费</span>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(item, index) in dateArr"
        :key="index"
        prop="type"
        align="center"
        :label="item"
        width="150"
      >
        <template v-slot:default="{row}">
          <span v-if="row.data[item]">{{ scientificFormat(row.data[item]) }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
    </el-table>
  </el-col>
</template>
<script>
import { getUserSpinsRate } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'

export default {
  name: 'UserSpinRateChart',
  components: { },
  data() {
    return {
      tableData: [],
      dateArr: []
    }
  },
  methods: {
    scientificFormat,
    refresh(typ, queryParams) {
      getUserSpinsRate(queryParams).then(res => {
        if (res.data.data.length < 1) {
          return
        }
        const { data, dateArr } = res.data
        const resetArr = []
        for (const i in data) {
          const val = data[i]
          resetArr.push(val)
        }
        this.tableData = resetArr
        this.dateArr = dateArr
      })
    }
  }
}
</script>

<style scoped>

</style>
